import { render, staticRenderFns } from "./EducationDetail.vue?vue&type=template&id=4a50d848&scoped=true"
import script from "./EducationDetail.vue?vue&type=script&lang=js"
export * from "./EducationDetail.vue?vue&type=script&lang=js"
import style0 from "./EducationDetail.vue?vue&type=style&index=0&id=4a50d848&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50d848",
  null
  
)

export default component.exports